<template>
    <component :is="tag" :class="classes">
        {{ formattedTitle.firstSection }}
        <a :href="link" target="_blank" class="scc-heading__link" :class="`scc-heading__link--${linkColor}`">
            {{ formattedTitle.markerSection }}
        </a>
        {{ formattedTitle.lastSection }} {{ appendTitle }}
    </component>
</template>

<script>
import './heading.scss';

import { format } from 'date-fns';
import localeObject from 'date-fns/locale/nl';
import cloneDeep from 'lodash/cloneDeep';

export default {
    name: 'Heading',
    __editor: {
        requiredData: ['drawings'],
        fields: {
            alignment: {
                widget: 'select',
                values: ['left', 'center', 'right'],
            },
            tag: {
                widget: 'select',
                values: ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'],
            },
            margin: {
                widget: 'select',
                values: ['none', 'small', 'medium', 'large', 'x-large'],
            },
            color: {
                widget: 'select',
                values: ['primary', 'secondary', 'body', 'white'],
            },
            linkColor: {
                widget: 'select',
                values: ['primary', 'secondary', 'body', 'white'],
            },
            append: {
                widget: 'select',
                values: ['none', 'last-drawing'],
            },
        },
    },
    props: {
        drawings: {
            type: Array,
        },
        title: {
            type: String,
            default: 'Title',
        },
        alignment: {
            type: String,
            default: 'left',
        },
        large: {
            type: Boolean,
            default: false,
        },
        tag: {
            type: String,
            default: 'h1',
            validator: function(val) {
                return ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'].includes(val);
            },
        },
        margin: {
            type: String,
            default: undefined,
        },
        color: {
            type: String,
            default: 'primary',
            validator: function(val) {
                return ['primary', 'secondary', 'body', 'white'].includes(val);
            },
        },
        linkColor: {
            type: String,
            default: 'secondary',
            validator: function(val) {
                return ['primary', 'secondary', 'body', 'white'].includes(val);
            },
        },
        link: {
            type: String,
        },
        linkMarker: {
            type: String,
        },
        append: {
            type: String,
            default: 'none',
            validator: function(val) {
                return ['none', 'last-drawing'].includes(val);
            },
        },
    },
    computed: {
        classes() {
            let classes = ['scc-heading', `scc-heading--${this.color}`, `scc-heading--align-${this.alignment}`];
            if (this.margin) classes.push(`scc-heading--margin-${this.margin}`);
            if (this.large) classes.push('scc-heading--title title');

            return classes;
        },
        formattedTitle() {
            if (!this.linkMarker) return { firstSection: this.title };

            if (!this.title.includes(this.linkMarker)) return 'Marker is not contained in sentence';

            const sentenceSections = this.title.split(this.linkMarker);

            if (sentenceSections.length > 2) return 'Marker is mentioned twice in sentence';

            return {
                firstSection: sentenceSections[0],
                markerSection: ' ' + this.linkMarker,
                lastSection: sentenceSections[1],
            };
        },
        appendTitle() {
            switch (this.append) {
                case 'last-drawing':
                    return this.lastDrawingString;
                case 'none':
                    return null;
                default:
                    return null;
            }
        },
        lastDrawingString() {
            return format(new Date(this.pastDrawing.publishAt), 'MMMM yyyy', { locale: localeObject });
        },
        pastDrawing() {
            const allDrawings = cloneDeep(this.drawings);
            let drawings = allDrawings.sort((a, b) => {
                return new Date(b.publishAt) - new Date(a.publishAt);
            });
            return drawings.find(drawing => {
                return new Date(drawing.publishAt) < new Date();
            });
        },
    },
};
</script>
